$(document).ready(function () {
  var getAttCount = $(this).find(".count-result-price").attr("getCountAtt");
  $(".custom-count-price-add").text(getAttCount);
  const priceVal = $(".custom-varinat-input-name:checked").attr(
    "cuspricecount"
  );
  const priceSplitVal = priceVal.split("$");
  const qtyVal = $(".custom-varinat-input-name:checked").val();
  const qtySplitVal = qtyVal.split(" ");
  const pricePerPiece = priceSplitVal[1] / qtySplitVal[0];
  if (pricePerPiece) {
    const perPieceVal = pricePerPiece.toFixed(2).replace(/(\.00\0+|0+)$/, "");
    const dta = perPieceVal.split(".");
    if (dta[1]) {
      $(".custom-count-price-add").text("($" + perPieceVal + "/count)");
    } else {
      $(".custom-count-price-add").text("($" + dta[0] + ".0" + "/count)");
    }
  }
  $(".custom_input_change").click(function () {
    if ($('.subscription-radio').hasClass('rc-radio--active')) {
      // Change the JS variable
    window.variantStrings.addToCart = "Start Autoship";
    const submitButton = document.querySelector(".custom-product-form__submit");
    const span = submitButton?.querySelector("span");
    if (span) {
      span.textContent = window.variantStrings.addToCart;
    }
    }
    var getAttCount = $(this).find(".count-result-price").attr("getCountAtt");
    var prohandle = $(this).data('prohandle');
    var vartitle = $(this).parent('.slideitem').find('.custom-varinat-input-name').val();

    var count = $('input[name="Count"]:checked , input[name="Choose Count:"]:checked').val(); 
    var scent = $('input[name="Size"]:checked , input[name="Scent"]:checked , input[name="Choose Scent:"]:checked, input[name="Scent:"]:checked').val();
    var countDataon = $(this).parents('.option-custom-no-1').attr('dataon');
    var scentDataon =  $(this).parents('.option-custom-no-2').attr('dataon');
    if(countDataon){
      if(scent){
        var variantTitlewithOption = vartitle+' / '+scent;
      }else{
        var variantTitlewithOption = vartitle;
      }
      variantdata(prohandle,variantTitlewithOption);
    }else{
      var variantTitlewithOption = count+' / '+vartitle;
      variantdata(prohandle,variantTitlewithOption);
    }
    
    if (getAttCount) {
      $(".custom-count-price-add").text(getAttCount);
    }
  });
});


function variantdata(productHandle, variantTitle) {
  $.getJSON("/products/" + productHandle + ".js", function(result) {

    let matchedMedia = [];

    $.each(result.media, function(i, media) {
      if (!media.alt) return;
      if (media.alt.indexOf('_') !== -1) {
        let parts = media.alt.split('_');
        if (parts[1] && parts[1].trim() === variantTitle.trim()) {
          matchedMedia.push(media);
        }
      }
    });

    if (matchedMedia.length === 0) {
      $('.slider-for-variant').slick('slickGoTo', 0);
      $('.desktop-slider-nav-variant').slick('slickGoTo', 0);
      $('.slider-nav-variant').slick('slickGoTo', 0);
      return;
    }

    //  remove all slides properly
    $('.slider-for-variant').slick('slickRemove', null, null, true);
    $('.desktop-slider-nav-variant').slick('slickRemove', null, null, true);
    $('.slider-nav-variant').slick('slickRemove', null, null, true);

    // add slides with correct wrapper
    $.each(matchedMedia, function(i, media) {

      $('.slider-for-variant').slick('slickAdd',
        `<div>
          <div class="item img-wrapper variant_item_img">
            <img src="${media.preview_image.src}" loading="lazy" alt="${media.alt}" class="item product_image_1">
          </div>
        </div>`
      );

      $('.desktop-slider-nav-variant').slick('slickAdd',
        `<div>
          <div class="item a variant_item_img">
            <img src="${media.preview_image.src}" loading="lazy" alt="${media.alt}" class="item product_image_2">
          </div>
        </div>`
      );

      $('.slider-nav-variant').slick('slickAdd',
        `<div>
          <div class="item variant_item_img">
            <img class="thumbnail-img" src="${media.preview_image.src}" loading="lazy" alt="${media.alt}" class="item product_image_3">
          </div>
        </div>`
      );
    });

    //reset + force slick recalc
    $('.slider-for-variant').slick('slickGoTo', 0, true);
    $('.desktop-slider-nav-variant').slick('slickGoTo', 0, true);
    $('.slider-nav-variant').slick('slickGoTo', 0, true);

    $('.slider-for-variant').slick('refresh').slick('setPosition');
    $('.desktop-slider-nav-variant').slick('refresh').slick('setPosition');
    $('.slider-nav-variant').slick('refresh').slick('setPosition');
  });
}

// function variantdata(productHandle, variantTitle) {

//   $.getJSON("/products/" + productHandle + ".js", function (result) {

//     let matchedMedia = [];

//     // Collect all media having same variant alt
//     $.each(result.media, function (i, media) {

//       if (!media.alt) return;

//       // expects alt format: Title_variantTitle
//       if (media.alt.indexOf('_') !== -1) {
//         let parts = media.alt.split('_');

//         // flexible match (handles extra spaces)
//         if (parts[1] && parts[1].trim().includes(variantTitle.trim())) {

//           // prevent duplicates
//           let exists = matchedMedia.some(m =>
//             (m.preview_image?.src && media.preview_image?.src && m.preview_image.src === media.preview_image.src)
//             || (m.id && media.id && m.id === media.id)
//           );

//           if (!exists) {
//             matchedMedia.push(media);
//           }
//         }
//       }
//     });

//     // If no match -> fallback goTo first
//     if (matchedMedia.length === 0) {
//       $('.slider-for-variant').slick('slickGoTo', 0);
//       $('.desktop-slider-nav-variant').slick('slickGoTo', 0);
//       $('.slider-nav-variant').slick('slickGoTo', 0);
//       return;
//     }

//     //  Remove all slides safely
//     $('.slider-for-variant').slick('slickRemove', null, null, true);
//     $('.desktop-slider-nav-variant').slick('slickRemove', null, null, true);
//     $('.slider-nav-variant').slick('slickRemove', null, null, true);

//     // Add all matched media slides
//     $.each(matchedMedia, function (i, media) {

//       //  VIDEO
//       if (media.media_type === 'video' || media.media_type === 'external_video') {

//         let videoUrl = '';
//         if (media.sources && media.sources.length > 0) {
//           videoUrl = media.sources[0].url;
//         }

//         // main slider video
//         $('.slider-for-variant').slick('slickAdd',
//           `<div>
//             <div class="item img-wrapper variant_item_img">
//               <video width="100%" controls autoplay muted poster="${media.preview_image.src}">
//                 <source src="${videoUrl}" type="video/mp4">
//               </video>
//             </div>
//           </div>`
//         );

//         // desktop thumbnails video poster
//         $('.desktop-slider-nav-variant').slick('slickAdd',
//           `<div>
//             <div class="item a variant_item_img">
//               <img src="${media.preview_image.src}" loading="lazy" alt="${media.alt}">
//             </div>
//           </div>`
//         );

//         // mobile thumbnails video poster
//         $('.slider-nav-variant').slick('slickAdd',
//           `<div>
//             <div class="item variant_item_img">
//               <img class="thumbnail-img" src="${media.preview_image.src}" loading="lazy" alt="${media.alt}">
//             </div>
//           </div>`
//         );

//       } else {
//         // IMAGE
//         $('.slider-for-variant').slick('slickAdd',
//           `<div>
//             <div class="item img-wrapper variant_item_img">
//               <img src="${media.preview_image.src}" loading="lazy" alt="${media.alt}">
//             </div>
//           </div>`
//         );

//         $('.desktop-slider-nav-variant').slick('slickAdd',
//           `<div>
//             <div class="item a variant_item_img">
//               <img src="${media.preview_image.src}" loading="lazy" alt="${media.alt}">
//             </div>
//           </div>`
//         );

//         $('.slider-nav-variant').slick('slickAdd',
//           `<div>
//             <div class="item variant_item_img">
//               <img class="thumbnail-img" src="${media.preview_image.src}" loading="lazy" alt="${media.alt}">
//             </div>
//           </div>`
//         );
//       }

//     });

//     //Reset slick
//     $('.slider-for-variant').slick('slickGoTo', 0, true);
//     $('.desktop-slider-nav-variant').slick('slickGoTo', 0, true);
//     $('.slider-nav-variant').slick('slickGoTo', 0, true);

//     // Force refresh + fix hide issue
//     $('.slider-for-variant').slick('refresh').slick('setPosition');
//     $('.desktop-slider-nav-variant').slick('refresh').slick('setPosition');
//     $('.slider-nav-variant').slick('refresh').slick('setPosition');

//   });

// }



